// Set utils function parseTime to filter
export { parseTime, formatTime } from "@/utils";

// Filter to uppercase the first character
export const uppercaseFirstChar = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const boolFilter = (boolInfo: boolean) => {
  if (boolInfo === true) {
    return "是";
  }
  return "否";
};
